export default __webpack_public_path__ + "static/media/EM0680.34I-22030_-15019_0.74059927.jpg";